import { PurchaseRouting } from "./../../purchase/purchase.routing";
import { HttpService } from "@/core";
import { generateUuid } from "@/utils";
import { TeamPageReq, TeamPageResp } from "./team.interface";

export class TeamService {
  static usePageApi() {
    const api = (data: TeamPageReq) =>
      HttpService.axios({
        method: "POST",
        url: "/maintenance_team/page",
        data,
      });
    return HttpService.usePagination<TeamPageResp>(api);
  }

  static useAddTeamUserApi() {
    const api = (data={}) =>
      HttpService.axios({
        method: "POST",
        url: `/maintenance_team/add`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }
  static useDeleteTeamUserApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: `/maintenance_team/batch/remove`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }

  static useUpdateTeamUserApi() {
    const api = (projectTeamIndependentId, data) =>
      HttpService.axios({
        method: "PUT",
        url: `/project_team_independent_user/${projectTeamIndependentId}/updateDate`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }

  static useSimpleListApi() {
    const api = (params={}, url = "/maintenance_team/list") =>
      HttpService.axios({
        method: "POST",
        url,
        data:params,
      });
    return HttpService.usePagination<any>(api);
  }
}
